// 注册楼栋
function postBlock (form, success, error) {
  const url = this.$store.state.blockUrl + 'save'
  let {blockName, city, province, district} = form
  let req = {
    blockName,
    city,
    province,
    district,
  }
  this.$http.post(url, req).then((res) => {
    if (res.body.code === 200) {
      success && typeof success === 'function' && success(res)
    } else {
      this.$message({
        message: res.body.message,
        type: 'error'
      })
      this.clickOver = true
      error && typeof error === 'function' && error(res)
    }
  })
}

// 建立委托合同
function postDelegateForm (form, success, error) {
  let apiUrl = this.$store.state.contractUrl + 'addDelegateContract'
  this.$http.post(apiUrl, {
    ...form,
    startTime: this.moment(form.startTime).format('YYYY-MM-DDT00:00:00'),
    endTime: this.moment(form.endTime).format('YYYY-MM-DDT00:00:00'),
  }).then(res => {
    if (res.data.code === 200) {
      success && typeof success === 'function' && success(res)
    } else {
      error && typeof error === 'function' && error(res)
    } 
  }, () => {
    this.clickOver = true
  })
}

// 注册房源
function postHouseForm (form, success, error) {
  let houseUrl = this.$store.state.houseUrl + 'save/houseSpaceManager'
  
  this.$http.post(houseUrl, {
    'bedroomNumber': form.bedroomNumber,
    'currentFloor': form.currentFloor,
    'blockName': form.blockName,
    'buildingNo': form.buildingNo,
    'unitNo': form.unitNo,
    'getPrice': form.rental,
    'houseSpaceManagerArea': form.houseSpaceManagerArea1 * 1000,
    'houseSpaceManagerDirection': form.direction,
    'houseSpaceManagerType': 'HOUSE',
    'inputPersonnelId': this.$store.state.currentUser.uid,
    'kitchenNumber': form.kitchenNumber,
    'landlordCertNumber': form.certificateNum,
    'landlordCertType': form.certificateType,
    'landlordName': form.userName,
    'landlordPhone': form.userPhone,
    'livingRoomNumber': form.livingRoomNumber,
    'propertyType': 'D',
    'originalRentType': form.rentType,
    'roomNo': form.roomNo,
    'toiletNumber': form.toiletNumber,
    'zoneId': form.zoneId,
    'zone': form.zone,
    'decorateType': form.decorateType,
    'insuranceStatus': form.insuranceStatus,
    'houseOwnershipCertificateNumber': form.houseOwnershipCertificateNumber,
    'province': form.province,
    'city': form.city,
    'district': form.district,
    'blockId': form.blockId,
    'floorHeight': form.floorHeight,
    'houseOwnershipCertificateType': form.houseCertificateType
  }).then(res => {
    if (res.body.code === 200 || res.body.code === 10002) {
      success && typeof success === 'function' && success(res)                      
    } else {
      this.$message.error(res.body.message)
      error && typeof error === 'function' && error(res)              
    }
  }, (res) => {
    this.clickOver = true
  })
}

// 加载银行
function loadBankNameOptions () {
  this.$http.post(this.bankSearch, {'baseDataType': 'FIRST_LEVEL_BANK_INFO'}).then((res) => {
    if (res.body.code === 200) {
      this.options.bankName = res.body.data
      this.form.bankName = res.body.data[0].bankName
      let req = {
        baseDataType: 'SECOND_LEVEL_BANK_INFO',
        bankName: res.body.data[0].bankName,
      }
      this.$http.post(this.bankSearch, req).then(res => {
        if (res.body.code === 200) {
          this.options.bankOfAccounts = res.body.data
        }
      })
    }
  })
}

function fetchProvinces () {
  return this.$http.post(this.bankSearch, {'baseDataType': 'PROVINCE__INFO'})
}

function fetchCities (provinceId) {
  return this.$http.post(this.bankSearch, {'baseDataType': 'CITY_INFO', provinceId})
}

function fetchDistrict (cityId) {
  return this.$http.post(this.bankSearch, {'baseDataType': 'AREA_INFO', cityId})
}

export default {
  postBlock,
  postDelegateForm,
  postHouseForm,
  loadBankNameOptions,
  fetchProvinces,
  fetchCities,
  fetchDistrict,
}



// WEBPACK FOOTER //
// ./src/components/forms/TrusteeshipForm/api.js